<template>
  <button
    v-if="$auth.isAuthenticated"
    class="btn btn-danger btn-block"
    @click.prevent="logout"
  >
    <v-icon>
      mdi-logout
    </v-icon>
    Log out
  </button>
</template>

<script>
  export default {
    name: 'LogoutButton',
    methods: {
      logout () {
        this.$auth.logout()
        this.$router.push({ path: '/' })
      },
    },
  }
</script>
